import { AddToCartModel } from "../models/Cart";
import { EventBus } from "../events";
import { productStore } from "@/store/ProductModule";

class Cart {

    public add(model: AddToCartModel, sourceElement: Element): void {

        window.Accelerator.libs.cart.addArticle(model, sourceElement);

        if (window.eventBus) {
            if (model.variantSystemId !== "") {
                const currentVariant = productStore.variants.find(x => x.variantSystemId === model.variantSystemId);
                const carbonSavingModel =  currentVariant ? currentVariant.carbonSavingsModel : null;
                EventBus.$emit("productAddedToCart", model.variantSystemId, carbonSavingModel, model.quantity,
                false);
            } else if (model.variantId !== "") {
                window.eventBus.$emit("productAddedToCartArticleNumber", model.variantId, true);
            }
        }
    }

    public addToCart(model: AddToCartModel): void {
        this.add(model, {} as Element);
    }

    public addToCartWithSingleAddedToCart(model: AddToCartModel, sourceElement: Element): void {
        window.Accelerator.libs.cart.addArticle(model, sourceElement);
    }

    public removeFromCart(model: AddToCartModel): void {
        window.Accelerator.libs.cart.removeArticle(model, {} as Element);
    }
}

export default new Cart();
